<template>
<div class="ibox">
    <div class="ibox-title">
        <div class="row">
            <div class="col-md-9">
                <h5>Perfil Público:</h5>
            </div>
            <div class="col-md-3">
                <button class="btn btn-md pull-right"
                        :class="isPrune ? 'btn-gray' : 'btn-primary'"
                        :disabled="isPrune"
                        @click="saveProfile"
                >
                    <strong>Salvar perfil</strong>
                </button>
            </div>
        </div>
    </div>
    <div class="ibox-content">
        <div class="row">
            <form action="/perfil"
                method="POST"
                id="formPerfilProfissional"
                enctype="multipart/form-data"
                @submit.prevent="onSubmit"
            >
                <div class="col-lg-6">
                    <div class="row">
                        <div class="form-group col-lg-12">
                            <label for="avatar">Insira sua foto</label>
                            <div class="perfil-image">
                                <img width="100%" :src="form.avatar" :alt="form.first_name">
                            </div>
                            <input type="file"
                                   id="avatar"
                                   class="upload-perfil-image"
                                   name="avatar"
                                   @change="previewAvatar"
                            >
                            <div class="col-md-12" style="color:grey">
                                <span>Clique na imagem para alterar. Tamanho máx. de 10MB.</span>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="form-group" style="margin-top:20px;">
                        <label for="field_id">Área de Atuação*</label>
                        <select name="field_id"
                                id="field_id"
                                class="form-control"
                                v-model="selectedField"
                        >
                            <option :value="null" selected>Selecione</option>
                            <option v-for="field in fields" :key="field.id" :value="field">
                                {{ field.name }}
                            </option>
                        </select>
                    </div>
                    <button class="btn btn-md btn-primary"
                            type="button"
                            @click="insertField"
                            :disabled="this.selectedField === null"
                    >
                        Inserir nova área
                    </button>
                    <div class="form-group" style="margin-top:10px;">
                        <label>Minhas Áreas de Atuação*</label>
                        <input v-bind:value="form.fields" name="locations" id="fields" type="text" class="form-control hide">
                        <ul class="regioesAtuacao" id="fieldsAtuacao">
                            <li v-for="field in form.fields" :key="field.id">
                                {{ field.name }}
                                <span class="btn-exclude"
                                      @click="removeField(field)"
                                >X</span>
                            </li>
                        </ul>
                    </div>
                    <hr>
                    <!--div class="form-group" style="margin-top:10px;">
                        <label for="skill">Especialidades</label>
                        <input type="text"
                            id="skill"
                            placeholder="Especialização #1"
                            name="skills[]"
                            class="form-control m-b inputPerfil"
                            v-model="form.skills[0]"
                        >
                        <input type="text"
                            placeholder="Especialização #2"
                            name="skills[]"
                            class="form-control m-b"
                            v-model="form.skills[1]"
                        >
                        <input type="text"
                            placeholder="Especialização #3"
                            name="skills[]"
                            class="form-control m-b"
                            v-model="form.skills[2]"
                        >
                    </div-->
                    <hr>
                    <div class="form-group" style="margin-top:10px;">
                        <label for="bio">Resumo Profissional</label>
                        <textarea type="text"
                                name="bio"
                                id="bio"
                                class="form-control inputPerfil"
                                v-model="form.bio"
                        ></textarea>
                    </div>
                </div> <!-- first form column -->
                <div class="col-lg-6">
                    <div class="form-group">
                        <label for="business_phone">Telefone Fixo/Comercial(Somente números. DDD+número)</label>
                        <input type="text"
                            name="business_phone"
                            id="business_phone"
                            class="form-control inputPerfil"
                            v-model="form.business_phone"
                               maxlength="11"
                               @keypress="isNumberKey"
                        >
                    </div>
                    <div class="form-group">
                        <label for="mobile_phone">Telefone Celular(Somente números. DDD+número)*</label>
                        <input type="text"
                            name="mobile_phone"
                            id="mobile_phone"
                            class="form-control inputPerfil"
                            v-model="form.mobile_phone"
                               maxlength="11"
                               @keypress="isNumberKey"
                        >
                    </div>
                    <hr>
                    <div class="form-group" style="margin-top: 10px">
                        <h3>Insira a sua região de atendimento <span style="font-size: smaller">(pode ser mais de uma)</span></h3>

                        <div class="form-group">
                            <label for="state_id">Estado</label>
                            <select name="state_id"
                                    id="state_id"
                                    class="form-control"
                                    @change="onChangeState"
                                    v-model="selectedState"
                            >
                                <option :value="null">Selecione</option>
                                <option v-for="state in states" :key="state.id" :value="state">
                                    {{ state.name }}
                                </option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="location">Cidade</label>
                            <select v-model="selectedCity" class="form-control" id="location">
                                <option :value="null" selected>Selecione</option>
                                <option v-for="city in cities" :key="city.id" :value="city">
                                    {{ city.name }}
                                </option>
                            </select>
                        </div>
                        <button class="btn btn-md btn-primary"
                                type="button"
                                @click="insertLocation"
                                :disabled="this.selectedCity === null"
                        >
                            Inserir nova região
                        </button>
                    </div>
                    <div class="form-group">
                        <label>Minhas Regiões de Atendimento*</label>
                        <input v-bind:value="form.locations" name="locations" id="locations" type="text" class="form-control hide">
                        <ul class="regioesAtuacao" id="regioesAtuacao">
                            <li v-for="location in form.locations" :key="location.id">
                                {{ location.name }} - {{ location.stateName }}
                                <span class="btn-exclude"
                                      @click="removeLocation(location)"
                                >X</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            form: {
                skills: [],
                field_id: null,
                schooling_level: null,
                locations: [],
                fields: [],
                type_save:'',
            },
            isPrune: true,
            fields: [],
            states: [],
            cities: [],
            selectedState: null,
            selectedCity: null,
            selectedField: null,
        };
    },

    methods: {
        isNumberKey(evt){
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (charCode > 31 && charCode != 48 && (charCode < 48 || charCode > 57 || charCode == 46))
                evt.preventDefault();
            return true;
        },
        onSubmit() {
            const form = Object.assign({}, this.form, {
                locations: this.form.locations.map(l => l.id),
                fields: this.form.fields.map(f => f.id),
            });

            axios.patch('/perfil', form)
                .then(() => {
                    this.refreshLocation();
                    toastr.success('Perfil salvo com sucesso');
                    checarForcaDoPerfil();
                    this.isPrune = true;
                }).catch((error) => {
                    this.formIsSending = false;
                    this.errors = error.response.data.errors;
                    var errorsText = "";
                    for(let [key, value] of Object.entries(this.errors)){
                        errorsText += value[0];
                    }
                    toastr.error(errorsText);
                });
        },
        saveProfile(){
            this.form.type_save = '';
            this.onSubmit();
        },
        onChangeState() {
            this.cities = [];
            this.selectedCity = null;

            if (!this.selectedState) {
                return;
            }

            axios.get(`/states/${this.selectedState.id}/cities`)
                .then(({data}) => {
                    this.cities = data.data;
                });
        },
        refreshLocation(){

            axios.get('/experts/locations')
                .then(({data}) => {
                    if (data.quantidade == 27) {
                        toastr.info("Atualizando regiões atendidas");
                        this.form.locations = data.locations;
                    }
                });

        },
        insertLocation() {


            axios.get('/experts/cities/'+this.selectedCity.id+'/validate')
                .then(({data}) => {
                    if(data.success){
                        const locationIds = this.form.locations.map(l => l.id);
                        if (this.selectedCity && !locationIds.includes(this.selectedCity.id)) {
                            this.form.locations.push(this.selectedCity);
                        }

                        this.selectedCity = null;
                        this.selectedState = null;
                        this.cities = [];
                        this.form.type_save = 'save_location';
                        this.onSubmit();
                    } else {
                        toastr.error(data.error);
                    }
                });
        },
        insertField() {


            axios.get('/experts/fields/'+this.selectedField.id+'/validate')
                .then(({data}) => {
                    if(data.success){
                        const fieldsIds = this.form.fields.map(l => l.id);
                        if (this.selectedField && !fieldsIds.includes(this.selectedField.id)) {
                            this.form.fields.push(this.selectedField);
                        }
                        this.form.type_save = 'save_field';
                        this.selectedField = null;
                        this.onSubmit();
                    } else {
                        toastr.error(data.error);
                    }
                });
        },
        removeLocation(location) {
            const locations = this.form.locations.filter(l => location !== l);

            this.form.locations = locations;

            this.onSubmit();
        },
        removeField(field) {
            const fields = this.form.fields.filter(f => field !== f);

            this.form.fields = fields;

            this.onSubmit();
        },
        previewAvatar(event) {
            var input = event.target;

            if (input.files && input.files[0]) {
                var reader = new FileReader();
                var vm = this;

                reader.onload = (e) => {
                    this.form.avatar = e.target.result;

                    let formData = new FormData();
                    formData.append('avatar', input.files[0]);
                    formData.append('_method', 'PATCH');
                    formData.append('type_save', 'save_field');
                    axios.post('/perfil', formData)
                        .then(() => {
                            toastr.success('Imagem Perfil salva com sucesso');
                        });
                };

                reader.readAsDataURL(input.files[0]);
            }
        },
    },

    watch: {
        form: {
            handler(newValue, oldValue) {
                this.isPrune = false;
            },
            deep: true,
        }
    },

    mounted() {
        axios.get('/profile')
            .then(({data}) => {
                this.form = Object.assign({}, this.form, data);
                this.$nextTick(() => {
                    this.isPrune = true;
                    checarForcaDoPerfil();
                });
            });

        axios.get('/fields')
            .then(({data}) => {
                this.fields = data;
            });

        axios.get('/states/state-all')
            .then(({data}) => {
                this.states = data;
            });
    }
}
</script>
